import { useState } from 'react';
import Navbar from '../Components/Navbar/Navbar';
import './ConnectAccess.css';

// This is a page-level privacy gate. Data authorization belongs on the server.
const passwordHash = '9dd86fc812d3b8926a417097f379f56a1743c27415093dca6ff28b3541b471a0';
let unlockedForSession = false;

export default function ConnectAccess({ children, pageName = 'Connect' }) {
  const [unlocked, setUnlocked] = useState(unlockedForSession);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setChecking(true);
    setError('');
    try {
      const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(password));
      const hash = Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
      if (passwordHash && hash === passwordHash) {
        unlockedForSession = true;
        setUnlocked(true);
        setPassword('');
      } else {
        setError('Incorrect password. Please try again.');
      }
    } catch {
      setError('Unable to check the password. Please reload and try again.');
    } finally {
      setChecking(false);
    }
  }

  if (unlocked) return children;

  return (
    <>
      <Navbar />
      <main className="connect-access">
        <form className="connect-access-card" onSubmit={handleSubmit}>
          <h1>{pageName} access</h1>
          <p>Enter the password to access {pageName}.</p>
          <label htmlFor="connect-password">Password</label>
          <input
            id="connect-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => { setPassword(event.target.value); setError(''); }}
            required
            aria-invalid={Boolean(error)}
            aria-describedby={error ? 'connect-access-error' : undefined}
          />
          {error && <p id="connect-access-error" role="alert">{error}</p>}
          {!passwordHash && <p role="status">{pageName} access is temporarily unavailable.</p>}
          <button type="submit" disabled={checking || !passwordHash}>
            {checking ? 'Checking…' : `Unlock ${pageName}`}
          </button>
        </form>
      </main>
    </>
  );
}
